import { GLOBO_ACCESS_RIGHTS } from "@/constants/accessRights";

export var globoMenuItems = [
    {
        id: "globo-patients", label: "Patient Masterlist", icon: "ri-team-fill", link: "/globo/patients",
        permissionTypeId: [GLOBO_ACCESS_RIGHTS.GLOBO_PATIENTS]
    },
    {
        id: "globo-doctors", label: "Physician Masterlist", icon: "ri-stethoscope-fill", link: "/globo/doctors",
        permissionTypeId: [GLOBO_ACCESS_RIGHTS.GLOBO_STATICDATA_DOCTORS]
    },
    {
        id: "globo-hospitals", label: "Hospitals / Clinics", icon: "ri-hospital-fill", link: "/globo/settings/hospitals",
        permissionTypeId: [GLOBO_ACCESS_RIGHTS.GLOBO_STATICDATA_HOSPITALS]
    },
    {
        id: "globo-adverse-events", label: "Adverse Events", icon: "ri-heart-pulse-line", link: "/globo/transactions/adverse-events",
        permissionTypeId: [GLOBO_ACCESS_RIGHTS.GLOBO_TRANSACTIONS_ADVERSEEVENTS]
    },
    {
        id: "globo-patient-enrollments", label: "Patient Enrollments", icon: "ri-user-heart-fill", link: "/globo/transactions/patient-enrollments",
        permissionTypeId: [
            GLOBO_ACCESS_RIGHTS.GLOBO_TRANSACTIONS_PATIENTENROLLMENTS_VIEWER,
            GLOBO_ACCESS_RIGHTS.GLOBO_TRANSACTIONS_PATIENTENROLLMENTS_REQUESTOR,
            GLOBO_ACCESS_RIGHTS.GLOBO_TRANSACTIONS_PATIENTENROLLMENTS_APPROVER]
    },
    {
        id: "globo-doctor-enrollments", label: "Physician Enrollments", icon: "ri-nurse-fill", link: "/globo/transactions/doctor-enrollments",
        permissionTypeId: [
            GLOBO_ACCESS_RIGHTS.GLOBO_TRANSACTIONS_DOCTORENROLLMENTS_VIEWER,
            GLOBO_ACCESS_RIGHTS.GLOBO_TRANSACTIONS_DOCTORENROLLMENTS_REQUESTOR,
            GLOBO_ACCESS_RIGHTS.GLOBO_TRANSACTIONS_DOCTORENROLLMENTS_APPROVER]
    },
    {
        id: "globo-prescription-requests", label: "Prescription Requests", icon: "ri-medicine-bottle-fill", link: "/globo/transactions/prescription-requests",
        permissionTypeId: [
            GLOBO_ACCESS_RIGHTS.GLOBO_TRANSACTIONS_PRESCRIPTIONREQUESTS_VIEWER,
            GLOBO_ACCESS_RIGHTS.GLOBO_TRANSACTIONS_PRESCRIPTIONREQUESTS_REQUESTOR,
            GLOBO_ACCESS_RIGHTS.GLOBO_TRANSACTIONS_PRESCRIPTIONREQUESTS_APPROVER]
    },
    {
        id: "globo-order-requests", label: "Orders / Availments", icon: "ri-capsule-fill", link: "/globo/transactions/order-requests",
        permissionTypeId: [
            GLOBO_ACCESS_RIGHTS.GLOBO_TRANSACTIONS_ORDERREQUESTS_VIEWER,
            GLOBO_ACCESS_RIGHTS.GLOBO_TRANSACTIONS_ORDERREQUESTS_REQUESTOR,
            GLOBO_ACCESS_RIGHTS.GLOBO_TRANSACTIONS_ORDERREQUESTS_APPROVER]
    },
    {
        id: "globo-loa-requests", label: "Letter of Availments", icon: "ri-heart-pulse-fill", link: "/globo/transactions/loa-requests",
        permissionTypeId: [
            GLOBO_ACCESS_RIGHTS.GLOBO_TRANSACTIONS_LOAREQUESTS_VIEWER,
            GLOBO_ACCESS_RIGHTS.GLOBO_TRANSACTIONS_LOAREQUESTS_REQUESTOR,
            GLOBO_ACCESS_RIGHTS.GLOBO_TRANSACTIONS_LOAREQUESTS_APPROVER]
    },
    { id: "globo-reports", label: "Reports", icon: "ri-stack-fill", link: "/globo/reports", permissionTypeId: [] },
    {
        id: "globo-settings", label: "Settings", icon: "ri-settings-2-fill", link: "/globo/settings",
        permissionTypeId: [
            GLOBO_ACCESS_RIGHTS.GLOBO_STATICDATA_DIAGNOSIS,
            GLOBO_ACCESS_RIGHTS.GLOBO_STATICDATA_DROPOUTREASONS,
            GLOBO_ACCESS_RIGHTS.GLOBO_STATICDATA_PATIENTSEGMENTS,
            GLOBO_ACCESS_RIGHTS.GLOBO_STATICDATA_PRINCIPALS,
            GLOBO_ACCESS_RIGHTS.GLOBO_STATICDATA_PRODUCTS,
            GLOBO_ACCESS_RIGHTS.GLOBO_STATICDATA_PROGRAMS,
            GLOBO_ACCESS_RIGHTS.GLOBO_STATICDATA_PURCHASINGACCOUNTS,
            GLOBO_ACCESS_RIGHTS.GLOBO_STATICDATA_THERAPEUTICAREAS,
            GLOBO_ACCESS_RIGHTS.GLOBO_STATICDATA_UOMS],
    },
];